export const GRAPH_LOAD_START = 'GRAPH_LOAD_START';
export const GRAPH_LOAD_SUCCESS = 'GRAPH_LOAD_SUCCESS';
export const GRAPH_LOAD_ERROR = 'GRAPH_LOAD_ERROR';
